import { memo } from 'react';

import { ExportPanel } from '@/components/flow';

import { SlideOut } from './SlideOut.tsx';

export type ExportPanelSlideOutProps = {
  actionId: string;
  hookId: string;
  agentId: string;
};

const IExportPanelSlideOut = ({ agentId, actionId }: ExportPanelSlideOutProps) => {
  return (
    <SlideOut>
      <ExportPanel agentId={agentId} actionId={actionId} />
    </SlideOut>
  );
};

export const ExportPanelSlideOut = memo(IExportPanelSlideOut) as typeof IExportPanelSlideOut;
